import controlPanel from './control_panel.json';
import gameList from './game_list.json';
import general from './general.json';
import leaderboard from './leaderboard.json';
import lineup from './lineup.json';
import teams from './teams.json';

const fantasyWishlist = { ...controlPanel, ...gameList, ...general, ...leaderboard, ...lineup, ...teams };

export { fantasyWishlist };
